import Customcss from './Popup.module.css'

export const Popup = ({ message, onClose, buttonClickHandler, showButton, buttonText }) => {
    return (
      <div className={Customcss.transactionpopup}>
        <div className={Customcss.popupcontent}>
          <span className={Customcss.closebtn} onClick={onClose}>&times;</span>
          <p>{typeof message === 'string' ? message : message?.map((text)=>{
            return <p>{text}</p>
          })}</p>
        {showButton?<button onClick={buttonClickHandler} className={Customcss.popupButton}>{buttonText}</button>:null}
        </div>
      </div>
    );
};